/* eslint-disable react/prop-types */
import React from 'react';
import { Button, TextField } from '@material-ui/core';
import Modal from 'components/Modal';
import classes from './Modal.module.scss';

const RenameModal = ({ open, title, placeholder, initialValue, handleClose, handleSubmit }) => {
  const [value, setValue] = React.useState(initialValue || '');
  React.useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const reset = () => {
    setValue('');
  };
  return (
    <Modal
      modalProps={{
        className: { classRoot: classes.root },
        open,
        handleClose: () => {
          setValue('');
          handleClose(reset);
        },
        title,
        size: 'small',
        footer: (
          <>
            <Button
              className={classes.button}
              color='primary'
              disabled={!value}
              variant='contained'
              onClick={() => {
                handleSubmit(value);
                setValue('');
              }}>
              Rename
            </Button>
          </>
        ),
      }}>
      <TextField
        className={classes.textField}
        variant='outlined'
        placeholder={placeholder}
        value={value}
        onChange={(event) => {
          setValue(event.target.value);
        }}
      />
    </Modal>
  );
};

export default RenameModal;
